import React from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

const FilterTextField = ({
                           type = "text",
                           fieldName,
                           placeholder,
                           handleBlur,
                           value,
                           handleSubmit,
                           setFieldValue,
                           containerStyles = 'col-lg',
                           inputStyles = 'form-control custom-form-control',
                           clearIconStyles = 'clear-filter-icon'
                         }) => {

  return (
    <div className={containerStyles}>
      <input
        type={type}
        className={inputStyles}
        name={fieldName}
        placeholder={placeholder}
        onBlur={handleBlur}
        value={value}
        onChange={(e) => {
          setFieldValue(fieldName, e.target.value);
          handleSubmit();
        }}
      />
      <img
        src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
        alt="clear-filter"
        className={clearIconStyles}
        onClick={() => {
          setFieldValue(fieldName, "");
          handleSubmit();
        }}
      />
    </div>
  );
}

export default FilterTextField;
